module.exports = __webpack_public_path__ + "img/instyle-mens-fragrances@2x.dc08053a.png";